/**
 * Torso outfit textures: ride-hailing
 */
import { CANVAS_FONTS } from '../../../../core/fonts.js';

export function drawTorso_grab(ctx, size, _options = {}) {
  // 4. ÁO KHOÁC TÀI XẾ GRAB
  ctx.fillStyle = '#00B14F'; // Xanh lá Grab
  ctx.fillRect(0, 0, size, size);

  // Sọc trắng ngang ngực
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, size * 0.38, size, size * 0.18);

  // Khóa kéo đen giữa áo
  ctx.fillStyle = '#1e293b';
  ctx.fillRect(size * 0.48, 0, size * 0.04, size);

  // Chữ Grab xanh trên nền trắng
  ctx.fillStyle = '#00B14F';
  ctx.font = `bold ${size * 0.12}px ${CANVAS_FONTS.sans}`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText('Grab', size * 0.5, size * 0.47);
}

export function drawTorso_be(ctx, size, _options = {}) {
  // 5. ÁO TÀI XẾ BE
  ctx.fillStyle = '#facc15'; // Vàng rực rỡ
  ctx.fillRect(0, 0, size, size);

  // Sọc xanh tím ngang ngực
  ctx.fillStyle = '#1e1b4b';
  ctx.fillRect(0, size * 0.36, size, size * 0.2);

  // Khóa kéo
  ctx.fillStyle = '#374151';
  ctx.fillRect(size * 0.48, 0, size * 0.04, size);

  // Chữ "be" vàng trên nền sọc tím
  ctx.fillStyle = '#facc15';
  ctx.font = `bold ${size * 0.13}px ${CANVAS_FONTS.sans}`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText('be', size * 0.5, size * 0.46);
}

export function drawTorso_xanh_sm(ctx, size, _options = {}) {
  // 6. ÁO TÀI XẾ TAXI XANH SM (VINFAST)
  ctx.fillStyle = '#06b6d4'; // Xanh ngọc lục lam Cyan đặc trưng
  ctx.fillRect(0, 0, size, size);

  // Viền xám bạc thanh lịch
  ctx.fillStyle = '#f1f5f9';
  ctx.fillRect(0, size * 0.35, size, size * 0.15);

  // Khóa kéo
  ctx.fillStyle = '#0f172a';
  ctx.fillRect(size * 0.48, 0, size * 0.04, size);

  // Biểu tượng chữ V VinFast / Xanh SM
  ctx.fillStyle = '#0891b2';
  ctx.font = `bold ${size * 0.1}px ${CANVAS_FONTS.sans}`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText('XANH SM', size * 0.5, size * 0.42);
}

export function drawTorso_shopee(ctx, size, _options = {}) {
  // 9. ÁO KHOÁC SHIPPER SHOPEE / TMĐT (Màu cam rực rỡ, sọc trắng & đen)
  ctx.fillStyle = '#ea580c'; // Cam Shopee đặc trưng
  ctx.fillRect(0, 0, size, size);

  // Cổ áo kéo khóa cao
  ctx.fillStyle = '#18181b';
  ctx.fillRect(size * 0.42, 0, size * 0.16, size * 0.18);
  ctx.strokeStyle = '#ffffff';
  ctx.lineWidth = size * 0.02;
  ctx.beginPath();
  ctx.moveTo(size * 0.5, 0);
  ctx.lineTo(size * 0.5, size * 0.18);
  ctx.stroke();

  // Dải sọc trắng phản quang ngang ngực
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, size * 0.38, size, size * 0.08);

  // Dải sọc đen thể thao bên dưới sọc trắng
  ctx.fillStyle = '#18181b';
  ctx.fillRect(0, size * 0.46, size, size * 0.04);

  // Khóa kéo kim loại dọc thân áo
  ctx.strokeStyle = '#e2e8f0';
  ctx.lineWidth = size * 0.015;
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.18);
  ctx.lineTo(size * 0.5, size);
  ctx.stroke();

  // Túi ngực có khóa kéo
  ctx.fillStyle = 'rgba(0, 0, 0, 0.25)';
  ctx.fillRect(size * 0.15, size * 0.58, size * 0.25, size * 0.18);
  ctx.strokeStyle = '#cbd5e1';
  ctx.lineWidth = size * 0.01;
  ctx.strokeRect(size * 0.15, size * 0.58, size * 0.25, size * 0.18);
}

export const ride_hailing_drawers = {
  grab: drawTorso_grab,
  be: drawTorso_be,
  xanh_sm: drawTorso_xanh_sm,
  shopee: drawTorso_shopee
};
